import { render, staticRenderFns } from "./WorkCollect.vue?vue&type=template&id=a83283c2&scoped=true&"
import script from "./WorkCollect.vue?vue&type=script&lang=js&"
export * from "./WorkCollect.vue?vue&type=script&lang=js&"
import style0 from "./WorkCollect.vue?vue&type=style&index=0&id=a83283c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83283c2",
  null
  
)

export default component.exports